/* eslint-disable vue/multi-word-component-names */
<template>
  <div class="container">
    <div class="columns is-centered">
      <div class="column">
        <h2>{{ $t('message.about') }}</h2>
        <h3>
          {{ $t('message.aboutTitle') }}
        </h3>
        <!-- <b>{{ $t('message.aboutSubTitle') }}</b>
        <br><br> -->
        <p class="faq-line-indent">
          {{ $t('message.paragraphOne') }}
        </p>
        <h3>{{ $t('message.aboutSubTitle') }} </h3>
        
        <p class="faq-line-indent">
          {{ $t('message.paragraphTwo.text') }}
          <ul>
            <li
              v-for="(bullet, index) in $t('message.paragraphTwo.bullets')"
              :key="index"
            >
              {{ bullet }}
            </li>
          </ul>
        </p>
    
        <p class="faq-line-indent">
          {{ $t('message.paragraphThree.text') }}
          <a
            :href="$t('message.paragraphThree.link.url')"
            target="_blank"
          > {{ $t('message.paragraphThree.link.text') }} </a>
          {{ $t('message.paragraphThree.continuation') }}
        </p>

        <p 
          class="faq-line-indent" 
        >
          {{ $t('message.finalConfirmation') }}
        </p>

        <!--Helpful Links -->
        <p class="faq-line" /><h3>
          {{ $t('message.resources') }}
        </h3>
        <ul>
          <li>
            <a
              :href="$t('message.code1.link.url')"
              target="_blank"
            > {{ $t('message.code1.link.text') }} </a>  
          </li>
          <li>
            <a
              :href="$t('message.code2.link.url')"
              target="_blank"
            > {{ $t('message.code2.link.text') }} </a>
          </li>
          <li>
            <a
              :href="$t('message.facts.link.url')"
              target="_blank"
            > {{ $t('message.facts.link.text') }}  </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
};
</script>

<style>
.faq-line {
margin:0in;
font-weight: bold;
}
.faq-line-indent {
margin:0in;
margin-left:.2in;
margin-bottom: 5px;
}
.faq-list{
  margin-left:100px !important
}
.last{
  margin-bottom: 50px;
}
</style>
